export default __webpack_public_path__ + "static/media/avatar_15.55a320cb.png";